var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    property,
    listing_index
  } = options;

__p+='\n\n<!-- Matching homes -->\n<div class="col-lg-4 col-md-4 col-sm-4 col-xs-4" data-omtag=\'finance:affordability-calculator:homes-you-may-like\'>\n  <div class="listing-'+
((__t=( listing_index ))==null?'':__t)+
' listing-container" title="'+
((__t=( property.address_display ))==null?'':__t)+
'">\n    <div class="photo-container pos-relative">\n      <!-- Listing photo -->\n      <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'" class="listing-photo display-block" target="_blank">\n        ';
 if(property.photo_url){ 
__p+='\n        <img data-src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" alt="'+
((__t=( property.address_display ))==null?'':__t)+
'" src="'+
((__t=( property.photo_url ))==null?'':__t)+
'" class="lazy-loaded">\n        ';
 } else { 
__p+='\n        <div class="coming-soon-img"></div>\n        ';
 } 
__p+='\n      </a>\n      <!-- End. Listing photo -->\n      <!-- Listing actions -->\n      <div class="listing-cta pos-absolute">\n        <div class="js-tracking" data-status="'+
((__t=( property.status ))==null?'':__t)+
'" data-propertyid="'+
((__t=( property.property_id ))==null?'':__t)+
'" data-listingid="'+
((__t=( property.listing_id ))==null?'':__t)+
'" data-source="MLS">\n          ';
 if ($.cookie('REMEMBER_ME')) { 
__p+='\n            ';
 resource_id = property.saved_resource_id 
__p+='\n            ';
 if (resource_id) { 
__p+='\n              <a class="js-delete-listing btn-save-listing removeFromSaved hp-unsave" data-res-id="'+
((__t=( resource_id ))==null?'':__t)+
'">\n                <i class="ra ra-heart icon-save icon-save-sm"></i>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart-o ra-stack-2x"></i>\n                  <i class="ra ra-heart icon-save ra-stack-1x"></i>\n                </span>\n              </a>\n              <a class="js-save-listing btn-save-listing addToSave hp-save" style="display:none">\n                <i class="ra ra-heart-o icon-save-sm js-no-listing-click"></i>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart-o ra-stack-2x"></i>\n                  <i class="ra ra-heart ra-stack-1x js-no-listing-click"></i>\n                </span>\n              </a>\n            ';
 } else { 
__p+='\n              <a class="js-save-listing btn-save-listing addToSave hp-save">\n                  <i class="ra ra-heart-o icon-save-sm js-no-listing-click" data-omtag=\'hp:card:save-listing\'></i>\n                  <span class="ra-stack icon-save-lg">\n                    <i class="ra ra-heart-o ra-stack-2x"></i>\n                    <i class="ra ra-heart ra-stack-1x js-no-listing-click"></i>\n                  </span>\n              </a>\n              <a class="js-delete-listing btn-save-listing removeFromSaved hp-unsave" style="display:none">\n                <i class="ra ra-heart icon-save icon-save-sm"></i>\n                <span class="ra-stack icon-save-lg">\n                  <i class="ra ra-heart-o ra-stack-2x"></i>\n                  <i class="ra ra-heart icon-save ra-stack-1x"></i>\n                </span>\n              </a>\n            ';
 } 
__p+='\n          ';
 } else { 
__p+='\n            <a class="js-save-listing btn-save-listing hp-save-not-logged-in" title="Save" href="#">\n              <i class="ra ra-heart-o icon-save-sm js-no-listing-click" data-omtag=\'hp:card:save-listing\'></i>\n              <span class="ra-stack icon-save-lg">\n                <i class="ra ra-heart-o ra-stack-2x"></i>\n                <i class="ra ra-heart ra-stack-1x js-no-listing-click"></i>\n              </span>\n            </a>\n          ';
 } 
__p+='\n        </div>\n      </div>\n      <!-- End. Listing actions -->\n      <!-- Listing information -->\n      <a href="'+
((__t=( property.ldp_url ))==null?'':__t)+
'">\n        <div class="listing-info pos-absolute">\n          <ul class="list-unstyled property-meta">\n            <li class="listing-info-price float-left">\n              '+
((__t=( property.price_display ))==null?'':__t)+
'\n            </li>\n            <li class="listing-info-meta float-left">\n              <ul class="list-horizontal list-style-slash">\n                ';
 if (property.beds) { 
__p+='\n                <li data-label="property-meta-beds"><span class="data-value">'+
((__t=( property.beds ))==null?'':__t)+
'</span> bd</li>\n                ';
 } 
__p+='\n                ';
 if (property.baths) { 
__p+='\n                <li data-label="property-meta-baths"><span class="data-value">'+
((__t=( property.baths ))==null?'':__t)+
'</span> ba</li>\n                ';
 } 
__p+='\n                ';
 if (property.sqft_display) { 
__p+='\n                <li data-label="property-meta-sqft"><span class="data-value">'+
((__t=( property.sqft_display ))==null?'':__t)+
'</span> sq ft</li>\n                ';
 } 
__p+='\n              </ul>\n            </li>\n            ';
 if (property.address_display) { 
__p+='\n            <li class="listing-info-address ellipsis">'+
((__t=( property.address_display ))==null?'':__t)+
'</li>\n            ';
 } 
__p+='\n            ';
 if (property.office_name) { 
__p+='\n            <li class="font-size-small">'+
((__t=( property.office_name ))==null?'':__t)+
'</li>\n            ';
 } 
__p+='\n          </ul>\n        </div>\n      </a>\n    </div>\n    <div class="listing-month-payment text-center">\n      <div>'+
((__t=( $('#matching_homes').attr('data') ))==null?'':__t)+
'</div>\n      ';
 if (property.monthly_payment) { 
__p+='\n        <span class="font-size-large">'+
((__t=( property.monthly_payment ))==null?'':__t)+
'</span>\n      ';
 } 
__p+='\n    </div>\n    <!-- End. Listing information -->\n  </div>\n</div>\n<!-- End. Matching homes -->\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/mortgage/matching_homes.jst.ejs